import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function AdminUsers() {
	const [users, setUsers] = useState([]);
	const [loading, setLoading] = useState(true);
	const navigate = useNavigate();

	useEffect(() => {
		async function load() {
			try {
				const res = await fetch('/api/admin/users', { credentials: 'include' });
				if (!res.ok) throw new Error('load failed');
				const data = await res.json();
				const list = Array.isArray(data) ? data : (data.data || []);
				setUsers(list);
			} catch (e) {
				console.error(e);
			} finally {
				setLoading(false);
			}
		}
		load();
	}, []);

	if (loading) return <div className="p-8 text-white">Загрузка...</div>;

	return (
		<div className="p-8 text-white max-w-7xl mx-auto">
			<h1 className="text-3xl font-bold mb-6">Пользователи</h1>
			<div className="space-y-4">
				{users.map(u => (
					<div key={u.id} className="rounded-2xl border border-white/10 bg-white/5 p-5">
						<div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
							<div>
								<div className="font-semibold text-lg">{u.email}</div>
								<div className="text-sm text-gray-400">
									ID: {u.id} · создан {u.created_at ? new Date(u.created_at).toLocaleString() : 'n/a'}
									{u.is_verified === false ? ' · не подтверждён' : ''}
								</div>
							</div>
							<div className="text-sm text-gray-300">
								{u.subscription ? `${u.subscription.rate} · ${u.subscription.status}` + (u.subscription.expires_at ? ` · до ${new Date(u.subscription.expires_at).toLocaleDateString()}` : '') : 'Нет подписки'}
							</div>
						</div>
						<div className="mt-3 text-sm text-gray-300">
							Telegram: {u.telegram_connected ? 'подключён' : 'нет'}
						</div>
						{(u.domains || []).length > 0 && (
							<div className="mt-3 flex flex-wrap gap-2">
								{u.domains.map(d => (
									<button
										key={d.id}
										onClick={() => navigate(`/dashboard?domain=${d.id}`)}
										className="px-3 py-1 rounded-lg bg-white/10 hover:bg-white/20 text-sm transition"
										title={d.verified ? 'Подключён' : 'Ожидает проверки'}
									>
										{d.domain} {!d.verified ? ' (ожидает)' : ''} {d.active === false ? ' [off]' : ''}
									</button>
								))}
							</div>
						)}
					</div>
				))}
				{users.length === 0 && <div className="text-gray-400">Пользователей нет</div>}
			</div>
		</div>
	);
}
